// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: white !important;
}

.under-img {
  margin-bottom: 80px !important;
}

.header-img {
  width: 125px !important;
  margin-top: 15px !important;
}

.login button {
  background-color: #192352 !important;
}

.header-img {
  width: 73px !important;
}

html, body, app-root, app-login-v4 {
  height: 100%;
  display: block;
}

app-login {
  display: flex;
  flex-direction: column;
  height: 100% !important;
}

body {
  background-color: white !important;
  position: relative;
  margin: 0 !important;
}

.under-img span {
  font-weight: 600;
}

.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9 {
  padding: 0 !important;
}

.login-container {
  margin: auto !important;
  padding: 30px;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.wrapper {
  margin: auto;
  width: 484px;
  text-align: center;
  padding: 40px 80px 50px 80px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff !important;
  box-shadow: 0 2px 6px 0 rgba(176, 186, 197, 0.6);
  z-index: 10;
  vertical-align: middle;
  position: relative;
}

.wrapper input {
  width: 100%;
  height: 55px;
  border-radius: 5px;
  border: solid 1px #ccd2d5;
  margin-bottom: 20px;
  background-color: transparent;
  padding-left: 57.5px;
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d;
  outline: none !important;
}

input:focus {
  border-color: #192352;
}

.wrapper input:last-of-type {
  margin-top: 0px;
}

.wrapper img {
  width: 75px;
}

.wrapper input:focus {
  border: solid 1px rgb(24, 115, 177);
}

.control-wrapper {
  text-align: left;
}

.input-password,
.input-username {
  position: relative;
}

.input-password:after,
.input-username:after {
  background: url('icon-password@3x.png');
  content: "";
  width: 22px;
  height: 23px;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 18px;
  top: 16.5px;
}

.input-username:after {
  background-image: url('icon-username@3x.png');
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}

.input-username {
  margin-top: 0px !important;
}

h1,
span {
  font-family: "asapregular";
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  /*letter-spacing: 4px;*/
  text-align: center;
  color: #313541;
}

h1 span {
  font-family: "asapmedium";
}

input[type=checkbox] {
  width: 18px;
  height: 100%;
  margin: 0 !important;
}

.sided {
  height: 30px;
  display: inline-table;
  table-layout: fixed;
  width: 100%;
  text-align: left;
}

.sided * {
  vertical-align: middle;
}

.sided input {
  display: none;
}

.sided label {
  width: 19px;
}

.sided .sided-child {
  margin-bottom: 10px;
}

.sided p {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #81898c;
  border-color: #ccd2d5;
  margin: 0 !important;
  padding-left: 12px !important;
  width: 100%;
  display: inline;
}

.login button {
  background-color: #192352;
  height: 55px;
  border-radius: 5px;
  width: 100%;
  font-family: "asapregular" !important;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border: 0 !important;
  color: #ffffff;
  cursor: pointer;
}

label input {
  display: none;
  /* Hide the default checkbox */
}

/* Style the artificial checkbox */
label span {
  height: 19px;
  width: 19px;
  border: 1px solid #ccd2d5;
  display: inline-block;
  position: relative;
  border-radius: 3px;
  cursor: pointer;
}

/* Style its checked state...with a ticked icon */
[type=checkbox]:checked + span:before {
  content: "";
  width: 14px;
  height: 9px;
  position: absolute;
  top: 6px;
  left: 2px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('cb-check.png');
}

.options {
  margin-top: 30px;
  display: table;
  width: 100%;
}

.options a,
.options a:hover,
.options a:visited {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  cursor: pointer;
  text-decoration: none !important;
  color: #81898c;
  display: table-cell;
}

.options a {
  margin-bottom: 15px;
}

.options a:first-of-type {
  text-align: left;
}

.options a:last-of-type {
  text-align: right;
}

.forgot-username-label {
  margin-bottom: 10px;
}

.inp-container {
  margin-bottom: 0 !important;
}

#clients {
  margin-top: 250px;
  text-align: center;
  margin-bottom: 70px;
}

.newpassword-label {
  margin-bottom: 20px;
}

.col {
  height: 252px;
}

#clients .logo {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: auto;
  height: 252px;
  display: inline-block;
  vertical-align: middle;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  font-family: "asapregular";
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3d464d !important;
}

@media screen and (max-width: 1200px) {
  .logo {
    width: 100%;
    margin-bottom: 50px !important;
  }
  #clients {
    margin-top: 150px !important;
  }
}
.unauthorize-message {
  padding: 20px;
  background-color: #d0021b;
  color: white;
  text-align: center;
  font-family: "asapregular" !important;
}

.error-messages {
  /*height:35px;*/
  padding-top: 10px;
}

.error-messages p {
  font-family: "asapregular";
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #e34c4c;
}

h1 {
  line-height: normal !important;
  padding: 0 !important;
}

button:disabled {
  background-color: #bebbbb !important;
}

.btn-loader {
  position: relative;
  margin-top: 60px;
}

.btn-loader img {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 30px;
  width: 30px;
}

.alerts .login-close-alert {
  top: 38px !important;
}

h1,
p,
a,
h2 {
  font-family: "asapbold";
  color: #060E37;
}

h1 {
  font-weight: bold;
  font-size: 22px;
}

.subtitle,
.login-foter p {
  margin: 20px 0 25px 0;
  font-size: 22px;
  font-family: "asapregular";
}

.v4-h {
  display: table;
  width: 85%;
  height: 140px;
  min-height: 140px;
  border-bottom: 2px solid #060E37;
}
.v4-h > * {
  display: table-cell;
  vertical-align: middle;
}
.v4-h > img {
  padding-left: 50px;
  height: 100%;
  object-fit: none;
}
.v4-h div {
  text-align: right;
}
.v4-h div * {
  padding-left: 30px;
}
.v4-h div img {
  height: 23px;
  vertical-align: sub;
}
.v4-h a {
  font-weight: bold;
  font-size: 15px;
  text-transform: uppercase;
}

.login-foter {
  display: flex;
  padding-top: 20px;
  flex-flow: nowrap;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f8f8f8;
  padding-top: 30px;
}
.login-foter p, .login-foter h2 {
  padding: 0;
  margin: 10px;
  font-size: 15px;
}
.login-foter > div {
  vertical-align: top;
}
.login-foter > div:first-of-type {
  padding-left: 120px;
  width: 50%;
}

.v4-main {
  display: flex;
  flex: 1;
}

.message {
  height: 25px;
  margin-bottom: 25px;
}
.message p {
  font-weight: normal;
  font-family: "asapregular";
  color: #d0021b;
  font-size: 15px;
}

.reg-container {
  padding: 30px !important;
}

.error-p {
  font-family: "asapregular" !important;
  color: red;
  margin-bottom: 20px;
  margin-top: -10px;
  width: 100%;
  text-align: left;
}

.error-input {
  border-color: red !important;
}

.p-success {
  color: #bed73b !important;
}

.loader-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 165px;
}

.options-centered * {
  text-align: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;AACJ;;AAOA;EACI,8BAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,2BAAA;AAJJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EACI,sBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,cAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,kCAAA;EACA,kBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgDI,qBAAA;AAJJ;;AAOA;EACI,uBAAA;EACA,aAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,0BAAA;AAJJ;;AAOA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gDAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,wBAAA;AAJJ;;AAOA;EACI,qBAxIa;AAoIjB;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAOA;EACI,mCAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;;EAEI,kBAAA;AAJJ;;AAOA;;EAEI,uCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAJJ;;AAOA;EACI,6CAAA;AAJJ;;AAOA;EACI,8CAAA;AAJJ;;AAOA;EACI,0BAAA;AAJJ;;AAQA;;EAEI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AALJ;;AAQA;EACI,yBAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;AALJ;;AAQA;EACI,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AALJ;;AAQA;EACI,sBAAA;AALJ;;AAQA;EACI,aAAA;AALJ;;AAQA;EACI,WAAA;AALJ;;AAQA;EACI,mBAAA;AALJ;;AAQA;EACI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;AALJ;;AAQA;EACI,yBA1Pa;EA2Pb,YAAA;EACA,kBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AALJ;;AAuBA;EACI,aAAA;EACA,8BAAA;AApBJ;;AAuBA,kCAAA;AACA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AApBJ;;AAuBA,iDAAA;AACA;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,qCAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;AApBJ;;AAuBA;;;EAGI,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;EACA,mBAAA;AApBJ;;AAuBA;EACI,mBAAA;AApBJ;;AAuBA;EACI,gBAAA;AApBJ;;AAuBA;EACI,iBAAA;AApBJ;;AAuBA;EACI,mBAAA;AApBJ;;AAuBA;EACI,2BAAA;AApBJ;;AAuBA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;AApBJ;;AAuBA;EACI,mBAAA;AApBJ;;AAuBA;EACI,aAAA;AApBJ;;AAuBA;EACI,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;AApBJ;;AAuBA;EACI,wBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,WAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AApBJ;;AAuBA;EACI;IACI,WAAA;IACA,8BAAA;EApBN;EAuBE;IACI,4BAAA;EArBN;AACF;AAwBA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;AAtBJ;;AAyBA;EACI,eAAA;EACA,iBAAA;AAtBJ;;AAyBA;EACI,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAtBJ;;AAyBA;EACI,8BAAA;EACA,qBAAA;AAtBJ;;AAyBA;EACI,oCAAA;AAtBJ;;AAyBA;EACI,kBAAA;EACA,gBAAA;AAtBJ;;AAyBA;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAtBJ;;AAyBA;EACI,oBAAA;AAtBJ;;AAyBA;;;;EAII,uBAAA;EACA,cAAA;AAtBJ;;AAyBA;EACI,iBAAA;EACA,eAAA;AAtBJ;;AAyBA;;EAEI,qBAAA;EACA,eAAA;EACA,0BAAA;AAtBJ;;AAyBA;EACI,cAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,gCAAA;AAtBJ;AAwBI;EACI,mBAAA;EACA,sBAAA;AAtBR;AAyBI;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AAvBR;AA0BI;EACI,iBAAA;AAxBR;AA0BQ;EACI,kBAAA;AAxBZ;AA2BQ;EACI,YAAA;EACA,mBAAA;AAzBZ;AA6BI;EACI,iBAAA;EACA,eAAA;EACA,yBAAA;AA3BR;;AA+BA;EACI,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AA5BJ;AA8BI;EACI,UAAA;EACA,YAAA;EACA,eAAA;AA5BR;AA+BI;EACI,mBAAA;AA7BR;AAgCI;EACI,mBAAA;EACA,UAAA;AA9BR;;AAkCA;EACI,aAAA;EACA,OAAA;AA/BJ;;AAkCA;EACI,YAAA;EACA,mBAAA;AA/BJ;AAgCI;EACI,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;AA9BR;;AAkCA;EACI,wBAAA;AA/BJ;;AAkCA;EACI,qCAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AA/BJ;;AAkCA;EACI,4BAAA;AA/BJ;;AAkCA;EACI,yBAAA;AA/BJ;;AAkCA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AA/BJ;;AAkCA;EACI,6BAAA;AA/BJ","sourcesContent":["body{\n    background-color: white !important;\n}\n\n\n\n$highlightColor: #192352;\n$loginPageButtonColor: #192352;\n\n.under-img {\n    margin-bottom: 80px !important;\n}\n\n.header-img {\n    width: 125px !important;\n    margin-top: 15px !important\n}\n\n.login button {\n    background-color: $loginPageButtonColor !important;\n}\n\n.header-img{\n    width: 73px !important;\n}\n\nhtml,body,app-root,app-login-v4{\n    height: 100%;\n    display: block;\n}\n\napp-login{\n    display: flex;\n    flex-direction: column;\n    height: 100% !important;\n}\n\nbody {\n    background-color: white !important;\n    position: relative;\n    margin: 0 !important;\n}\n\n.under-img span {\n    font-weight: 600;\n} \n\n.col-lg-1,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-md-1,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-sm-1,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-xs-1,\n.col-xs-10,\n.col-xs-11,\n.col-xs-12,\n.col-xs-2,\n.col-xs-3,\n.col-xs-4,\n.col-xs-5,\n.col-xs-6,\n.col-xs-7,\n.col-xs-8,\n.col-xs-9 {\n    padding: 0 !important;\n}\n\n.login-container {\n    margin: auto !important;\n    padding: 30px;\n}\n\n.row {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n\n.wrapper {\n    margin: auto;\n    width: 484px;\n    text-align: center;\n    padding: 40px 80px 50px 80px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    background-color: #ffffff !important;\n    box-shadow: 0 2px 6px 0 rgb(176 186 197 / 60%);\n    z-index: 10;\n    vertical-align: middle;\n    position: relative;\n}\n\n.wrapper input {\n    width: 100%;\n    height: 55px;\n    border-radius: 5px;\n    border: solid 1px #ccd2d5;\n    margin-bottom: 20px;\n    background-color: transparent;\n    padding-left: 57.5px;\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #3d464d;\n    outline: none !important;\n}\n\ninput:focus {\n    border-color: $highlightColor;\n}\n\n.wrapper input:last-of-type {\n    margin-top: 0px;\n}\n\n.wrapper img {\n    width: 75px;\n}\n\n.wrapper input:focus {\n    border: solid 1px rgb(24, 115, 177);\n}\n\n.control-wrapper {\n    text-align: left;\n}\n\n.input-password,\n.input-username {\n    position: relative;\n}\n\n.input-password:after,\n.input-username:after {\n    background: url(../../../assets/css/images/platform/icon-password@3x.png);\n    content: \"\";\n    width: 22px;\n    height: 23px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    position: absolute;\n    left: 18px;\n    top: 16.5px;\n}\n\n.input-username:after {\n    background-image: url(../../../assets/css/images/platform/icon-username@3x.png);\n}\n\ninput:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\n}\n\n.input-username {\n    margin-top: 0px !important;\n}\n\n\nh1,\nspan {\n    font-family: \"asapregular\";\n    font-size: 20px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    /*letter-spacing: 4px;*/\n    text-align: center;\n    color: #313541;\n}\n\nh1 span {\n    font-family: \"asapmedium\";\n}\n\ninput[type=\"checkbox\"] {\n    width: 18px;\n    height: 100%;\n    margin: 0 !important;\n}\n\n.sided {\n    height: 30px;\n    display: inline-table;\n    table-layout: fixed;\n    width: 100%;\n    text-align: left;\n}\n\n.sided * {\n    vertical-align: middle;\n}\n\n.sided input {\n    display: none;\n}\n\n.sided label {\n    width: 19px;\n}\n\n.sided .sided-child {\n    margin-bottom: 10px;\n}\n\n.sided p {\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #81898c;\n    border-color: #ccd2d5;\n    margin: 0 !important;\n    padding-left: 12px !important;\n    width: 100%;\n    display: inline;\n}\n\n.login button {\n    background-color: $highlightColor;\n    height: 55px;\n    border-radius: 5px;\n    width: 100%;\n    font-family: \"asapregular\" !important;\n    font-size: 14px;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    border: 0 !important;\n    color: #ffffff;\n    cursor: pointer;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nlabel input {\n    display: none;\n    /* Hide the default checkbox */\n}\n\n/* Style the artificial checkbox */\nlabel span {\n    height: 19px;\n    width: 19px;\n    border: 1px solid #ccd2d5;\n    display: inline-block;\n    position: relative;\n    border-radius: 3px;\n    cursor: pointer;\n}\n\n/* Style its checked state...with a ticked icon */\n[type=checkbox]:checked+span:before {\n    content: \"\";\n    width: 14px;\n    height: 9px;\n    position: absolute;\n    top: 6px;\n    left: 2px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-image: url(../../../assets/css/images/platform/cb-check.png);\n}\n\n.options {\n    margin-top: 30px;\n    display: table;\n    width: 100%;\n}\n\n.options a,\n.options a:hover,\n.options a:visited {\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: left;\n    cursor: pointer;\n    text-decoration: none !important;\n    color: #81898c;\n    display: table-cell;\n}\n\n.options a {\n    margin-bottom: 15px;\n}\n\n.options a:first-of-type {\n    text-align: left;\n}\n\n.options a:last-of-type {\n    text-align: right;\n}\n\n.forgot-username-label {\n    margin-bottom: 10px;\n}\n\n.inp-container {\n    margin-bottom: 0 !important;\n}\n\n#clients {\n    margin-top: 250px;\n    text-align: center;\n    margin-bottom: 70px;\n}\n\n.newpassword-label {\n    margin-bottom: 20px;\n}\n\n.col {\n    height: 252px;\n}\n\n#clients .logo {\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: auto;\n    height: 252px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #3d464d !important;\n}\n\n::-moz-placeholder {\n    /* Firefox 19+ */\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #3d464d !important;\n}\n\n:-ms-input-placeholder {\n    /* IE 10+ */\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #3d464d !important;\n}\n\n:-moz-placeholder {\n    /* Firefox 18- */\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #3d464d !important;\n}\n\n@media screen and (max-width: 1200px) {\n    .logo {\n        width: 100%;\n        margin-bottom: 50px !important;\n    }\n\n    #clients {\n        margin-top: 150px !important;\n    }\n}\n\n.unauthorize-message {\n    padding: 20px;\n    background-color: #d0021b;\n    color: white;\n    text-align: center;\n    font-family: \"asapregular\" !important;\n}\n\n.error-messages {\n    /*height:35px;*/\n    padding-top: 10px;\n}\n\n.error-messages p {\n    font-family: \"asapregular\";\n    font-size: 14px;\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    text-align: center;\n    color: #e34c4c;\n}\n\nh1 {\n    line-height: normal !important;\n    padding: 0 !important;\n}\n\nbutton:disabled {\n    background-color: #bebbbb !important;\n}\n\n.btn-loader {\n    position: relative;\n    margin-top: 60px;\n}\n\n.btn-loader img {\n    position: absolute;\n    right: 10px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    height: 30px;\n    width: 30px;\n}\n\n.alerts .login-close-alert {\n    top: 38px !important;\n}\n\nh1,\np,\na,\nh2 {\n    font-family: 'asapbold';\n    color: #060E37;\n}\n\nh1 {\n    font-weight: bold;\n    font-size: 22px;\n}\n\n.subtitle,\n.login-foter p {\n    margin: 20px 0 25px 0;\n    font-size: 22px;\n    font-family: 'asapregular'\n}\n\n.v4-h {\n    display: table;\n    width: 85%;\n    height: 140px;\n    min-height: 140px;\n    border-bottom: 2px solid #060E37;\n\n    >* {\n        display: table-cell;\n        vertical-align: middle;\n    }\n\n    >img {\n        padding-left: 50px;\n        height: 100%;\n        object-fit: none;\n    }\n\n    div {\n        text-align: right;\n\n        * {\n            padding-left: 30px;\n        }\n\n        img {\n            height: 23px;\n            vertical-align: sub;\n        }\n    }\n\n    a {\n        font-weight: bold;\n        font-size: 15px;\n        text-transform: uppercase;\n    }\n}\n\n.login-foter {\n    display: flex;\n    padding-top: 20px;\n    flex-flow: nowrap;\n    width: 100%;\n    padding-bottom: 30px;\n    background-color: #f8f8f8;\n    padding-top: 30px;\n\n    p,h2{\n        padding: 0;\n        margin: 10px;\n        font-size: 15px;\n    }\n\n    >div {\n        vertical-align: top;\n    }\n\n    >div:first-of-type {\n        padding-left: 120px;\n        width: 50%;\n    }\n}\n\n.v4-main{\n    display: flex;\n    flex: 1;\n}\n\n.message{\n    height: 25px;\n    margin-bottom: 25px;\n    p{\n        font-weight: normal;\n        font-family: 'asapregular';\n        color: #d0021b;\n        font-size: 15px;\n    }\n}\n\n.reg-container{\n    padding: 30px !important;\n}\n\n.error-p{\n    font-family: 'asapregular' !important;\n    color: red;\n    margin-bottom: 20px;\n    margin-top: -10px;\n    width: 100%;\n    text-align: left;\n}\n\n.error-input{\n    border-color: red !important;\n}\n\n.p-success{\n    color: #bed73b !important;\n}\n\n.loader-wrapper{\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 165px;\n}\n\n.options-centered *{\n    text-align: center !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
